/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/Redux/TestCasesActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { WorkItemDetails } from "TestPlanCommon/Contracts/TestPlan";
import { ILibraryWorkItemDataProviderState } from "Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryContracts";

export const TestCasesActions = {
    // Action to start/stop loading experience
    clearTestCasesAndSetLoadingExperience: () => createAction(TestCasesActionTypes.clearTestCasesAndSetLoadingExperience),

    // Action to initialize testcases pivot (like setup initial filter bar state etc.)
    initializeTestCasesPivot: () => createAction(TestCasesActionTypes.initializeTestCasesPivot),

    // Action to invoke loading the initial testcases as a part of page load
    loadInitialTestCases: () => createAction(TestCasesActionTypes.loadInitialTestCases),

    // Action to invoke when the initial testcases are fetched
    loadInitialTestCasesSucceeded: (testCases: WorkItemDetails[], workItemDataProviderState: ILibraryWorkItemDataProviderState) =>
        createAction(TestCasesActionTypes.loadInitialTestCasesSucceeded, { testCases, workItemDataProviderState }),

    // Action to load a subsequent page of test cases
    loadTestCasesPage: () => createAction(TestCasesActionTypes.loadTestCasesPage),

    // Action to invoke when subsequent page of test cases are fetched
    loadTestCasesPageSucceeded: (testCases: WorkItemDetails[], workItemDataProviderState: ILibraryWorkItemDataProviderState) =>
        createAction(TestCasesActionTypes.loadTestCasesPageSucceeded, { testCases, workItemDataProviderState }),

    // Action to invoke to update the data provider state in store
    updateProviderState: (newState: ILibraryWorkItemDataProviderState) => createAction(TestCasesActionTypes.updateProviderState, { newState })
};

export const enum TestCasesActionTypes {
    clearTestCasesAndSetLoadingExperience = "TestCasesPivot/clearTestCasesAndSetLoadingExperience",
    initializeTestCasesPivot = "TestCasesPivot/initializeTestCasesPivot",
    loadInitialTestCases = "TestCasesPivot/loadInitialTestCases",
    loadInitialTestCasesSucceeded = "TestCasesPivot/loadInitialTestCasesSucceeded",
    loadTestCasesPage = "TestCasePivot/loadTestCasesPage",
    loadTestCasesPageSucceeded = "TestCasePivot/loadTestCasesPageSucceeded",
    updateProviderState = "TestCasePivot/updateProviderState"
}

export type TestCasesActions = ActionsUnion<typeof TestCasesActions>;
